<template>
  <div class="use-ele today-alarm">
    <nk-box-title :icon-class="'iconfont icon-yongdiangaikuang1'" :title="'用电概况'">
      <!-- <div slot="title" class="logo"> -->
      <div slot="title" >
            <div class="timeDate">
                <span v-for="(item,index) in timeData" :key="index" @click="changeTime(item,index)"
                    :value="item.value" class="time-box dn-title-bg" :class="{'spanColor dn-content-bg':index==isActive }">{{item.value}}
                </span>
            </div>
      </div>
      <div class="content dn-content-bg" v-loading="ifLoad">
        <div class="main-centent">
          <div class="main-top">
            <div class="aq ">
              <div class="current ">
                  <div class="dateType xqh zt">当{{dateType}}用电</div>
                  <div class="ico-box red">
                      <span  v-if="eleData.currentPeriod===''">-</span>
                      <countTo  v-else :startVal="0" :endVal="parseFloat(eleData.currentPeriod)" :decimals="2" :duration="1000"></countTo>
                      <span class="wh">kW•h</span>
                      </div>
              </div>
            </div>
            <div class="aq">
              <div class="current ">
                  <div class="dateType xqh zt">上{{dateType}}同期</div>
                  <div class="ico-box green">
                      <span  v-if="eleData.prevPeriod===''">-</span>
                      <countTo v-else :startVal="0" :endVal="parseFloat(eleData.prevPeriod)" :decimals="2" :duration="1000"></countTo>
                      <span class="wh">kW•h</span>
                      </div>
              </div>
            </div>
            <div class="aq">
              <div class="current">
                    <div class="dateType xqh zt">环比</div>
                    <div class="ico-box yello">
                        <span  v-if="eleData.huanbi===''">-</span>
                        <countTo v-else :startVal="0" :endVal="parseFloat(eleData.huanbi)" :decimals="2" :duration="1000"></countTo>
                        <span class="wh">%</span>
                        <div class="small"><i  :class="hbClass"></i></div>
                    </div>
              </div>
            </div>
          </div>
          <div class="main-bottom ">
            <div class="aq">
              <div class="ico-img dn-content-bg zt line" style="margin-right:2px">
                  <p class="maxTime">{{eleData.maxPayLoadDate}}</p>  
                  <p class="timetop">最大用电时间</p>
              </div>
              <div class="ico-img dn-content-bg zt line " style="margin-left:2px">
                  <p class="szgl ">{{eleData.maxPayLoadVal}}<span class="danwei ">kVA</span></p>
                  <p class="timetop ">视在功率</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nk-box-title>
  </div>
</template>
<script>
import NkBoxTitle from "@/components/common/NkBoxTitle.vue";
import dateTool from '@/utils/dateTool'
import countTo from "vue-count-to";
var vm
export default {
  components: { NkBoxTitle,countTo },
  data() {
    return {
        timeData:[
            { id:'0',value:"日"},
            { id:'2',value:"月"},
            { id:'5',value:"年"},
        ],
        isActive:false,
        dateType:'日',
        eleData:{},
        time:60,
        interTime:null,
        hbClass:'iconfont icon-shangzhang sicon',
        startTime:'',
        endTime:'',
        ifLoad:false,
        clickTime:false
    };
  },
  created() {
        vm=this
        let time = new Date()
        vm.startTime = dateTool.format(time, 'yyyy-MM-dd ') + '00:00:00'
        time.setDate(time.getDate() + 1)
        vm.endTime = dateTool.format(time, 'yyyy-MM-dd') + ' 00:00:00'
        vm.getData(1)
  },
  mounted() {
      vm.maxTime=vm.eleData.maxTime
      vm.szgl=vm.eleData.szgl
  },
  methods: {
    changeTime(item ,index){
        let vm=this
        let time = new Date()
        vm.clickTime=true
        vm.isActive=index
        if(item.id=='0'){
            vm.dateType='日'
            vm.startTime = dateTool.format(time, 'yyyy-MM-dd ') + '00:00:00'
            time.setDate(time.getDate() + 1)
            vm.endTime = dateTool.format(time, 'yyyy-MM-dd') + ' 00:00:00'
            vm.getData(1)
        }else if(item.id=='2'){
            vm.dateType='月'
            vm.startTime = dateTool.format(time, 'yyyy-MM') + '/01 00:00:00'
            time.setMonth(time.getMonth() + 1)
            vm.endTime = dateTool.format(time, 'yyyy-MM') + '/01 00:00:00'
            vm.getData(2)
        }else{
            vm.dateType='年'
            vm.startTime = dateTool.format(time, 'yyyy') + '/01/01 00:00:00'
            time.setFullYear(time.getFullYear() + 1)
            vm.endTime = dateTool.format(time, 'yyyy') + '/01/01 00:00:00'
            vm.getData(3)
        }
    },
    getData(dateType){
        let vm = this
        if(vm.clickTime){
            vm.ifLoad=true
        }
        vm.$api.tmp.getWholePlantEnegeSumary(vm.$store.state.user.currentCompanyId,dateType,vm.startTime,vm.endTime).then(res=>{
            if(res.success){
                vm.ifLoad=false
                vm.clickTime=false
                if(dateType==1){
                    res.data.maxPayLoadDate=res.data.maxPayLoadDate.slice(11)
                }else if(dateType==2){
                    res.data.maxPayLoadDate=res.data.maxPayLoadDate.slice(8,13)
                }else{
                    res.data.maxPayLoadDate=res.data.maxPayLoadDate.slice(5,11)
                }
                res.data.maxPayLoadDate=res.data.maxPayLoadDate==''?'-':res.data.maxPayLoadDate
                res.data.maxPayLoadVal=res.data.maxPayLoadVal==''?'-':res.data.maxPayLoadVal
                vm.eleData= res.data
                if(res.data.huanbi==''||res.data.huanbi==0){  //判断环比箭头
                    vm.hbClass='iconfont icon-dengyu siconY'
                }else{
                    if(parseFloat(res.data.huanbi)>0){
                        vm.hbClass='iconfont icon-shangzhang sicon'
                    }else{
                        vm.hbClass='iconfont icon-xiajiang siconG'
                    }
                }
                if(vm.interTime){
                    clearTimeout(vm.interTime);
                }
                if(vm.time > 0){
                    vm.interTime = setTimeout(() => {
                        vm.getData(dateType)
                    }, vm.time * 1000);
                }
            }else{
                    vm.$message.error(res.msg)
                }
        }).catch(error=>{
            vm.$messge.error(error.msg)
        })
    }
  },
};
</script>
<style lang="scss" scoped>
.spanColor{
    color: #1D98EC;
    // background: #fff !important;
}
.use-ele {
    height: 100%;
    width: 100%;
    display: flex;
    flex-flow: column;
    .logo {
        line-height: 25px;
        display: flex;
        flex-flow: row;
        color: rgba(30, 30, 30);
        margin-left: 5px;
        .logoImg {
        margin-right: 5px;
        }
    }
    .timeDate{
        line-height: 38px;
        background: #fff;
        .time-box{
            display: inline-block;
            line-height: 39px;
            padding: 0 12px;
        }
    }
    .content {
        display: flex;
        flex: 1;
        flex-flow: column;
        padding: 8px;
        box-sizing: border-box;
        color: #181818;
        .main-centent{
            display: flex;
            flex: 2;
            flex-flow: column;
            .main-top{
                display: flex;
                flex: 1; 
                flex-flow: column;
                margin-top: 5px 0;
                .aq{
                    display: flex;
                    flex: 1;
                    flex-flow: row;
                    .current{
                        display: flex;
                        display: flex;
                        flex: 1;
                        border-radius: 1px;
                        justify-content: center;
                        align-items: center;
                        flex-flow: row;
                        margin-bottom: 8px;
                        .dateType{
                            display: flex;
                            flex: 2;
                            margin: 0;
                            justify-content: center;
                            align-items: center;
                            font-size: 18px;
                            font-weight: 600;
                            padding: 19px 0;
                            box-sizing: border-box;
                            border-radius: 4px;
                            // color:#242424;
                        }
                        .ico-box{
                            margin: 0;
                            display: flex;
                            flex: 3;
                            // background: #0197ee;
                            font-size: 34px;
                            border-radius: 3px;
                            padding: 12px;
                            justify-content: center;
                            // color: #fff;
                            .wh{
                                font-size: 12px;
                                padding-top: 17px;
                                box-sizing: border-box;
                                margin-left: 5px;
                            }
                            .small{
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                margin-left: 3px;
                                .sicon{
                                    font-size: 17px;
                                    color: rgba(207, 59, 19);
                                }
                                .siconG{
                                    font-size: 17px;
                                    color: green;
                                }
                                .siconY{
                                    font-size: 17px;
                                    color: yellow;
                                }
                            }
                        }
                    }
                    .main-value{
                        margin: 0;
                        display: flex;
                        flex: 1;
                        justify-content: center;
                        align-items: center;
                        font-size: 17px;
                        position: relative;
                        .small{
                            font-size: 12px;
                            margin-left: 2px;
                            margin-left: 3px;
                        }
                    }
                }
            }  
            .main-bottom{
                display: flex;
                flex: 1; 
                flex-flow: row;
                .aq{
                    display: flex;
                    flex: 1;
                    flex-flow: row;
                    .ico-img{
                        display: flex;
                        flex: 1;
                        justify-content: center;
                        align-items: center;
                        flex-flow: column;
                        // background: rgba(241, 242, 244);
                        justify-content: center;
                        align-items: center;
                            border-radius: 4px;
                        .maxTime{
                            margin: 0;
                            display: flex;
                            font-size: 34px;
                        }
                        .timetop{
                            font-size: 16px;
                            font-weight: 600;
                            margin: 0px;
                            margin-top: 5px;
                        }
                        .szgl{
                            margin: 0;
                            display: flex;
                            font-size: 34px;
                            .danwei{
                                font-size: 16px;
                                padding-top: 19px;
                                box-sizing: border-box;
                            }
                        }
                    }
                }
            }  
        }
    }
}
</style>